import { Accion } from './ComponenteBase';
export enum CodigoAccion {
  Consultar = 1,
  Crear = 2,
  Editar = 3,
  VerDetalle = 4,
  Eliminar = 5,
  Exportar = 6,
  GenerarEnvio = 123,
  CorteIgnicion = 7,
  Indicadores = 8,
  RepetirDia = 9,
  Desbloquear = 13,
  Cancelar = 48,
  Aceptar = 14,
  Rechazar = 16,
  DejarDeRecibir = 15,
  DejarDeCompartir = 17,
  AsociarRol = 10,
  AsociarUsuario = 11,
  AsociarCliente = 12,
  AgruparConductor = 18,
  AsociarFlota = 24,
  AsociarEtiqueta = 39,
  AsociarGps = 34,
  GenerarAsociarFlotasEtiquetasVehículos = 43,
  GenerarGenerarInforme = 44,
  GenerarInformaciónGeneral = 45,
  Compartir = 47,
  Importar = 50,
  Comunicaciones = 51,
  TrazarRutaInferida = 52,
  Descargar = 72,
  CambiarPassword = 88,
  Enviar = 90,
  detallesDashboard = 92,
  VerPdf = 89,
  VerReferencia = 91,
  EnviarComando = 95,
  Anular = 94,
  EliminarApn = 96,
  EditarApn = 97,
  EliminarStock = 98,
  EditarStock = 99,
  EliminarApnCrear = 100,
  EditarApnCrear = 101,
  EliminarStockCrear = 102,
  EditarStockCrear = 103,
  EliminarPlanCrear = 104,
  EditarPlanCrear = 105,
  cargarArchivo = 93,
  compartir = 47,
  Exportar_A_CRM = 106,
  VerHistorico = 112,
  SolicitarAutorizacion = 110,
  VerAutorizacion = 111,
  Traza = 114,
  InformarRecepcion = 118,
  EditarAutorizadores = 116,
  accionImportar = 108,
  accionRevertirEjecucion = 109,
  GenerarAtencion = 121,
  AccionReutilizable = 122,
  VerEstadoSeries = 120,
  IncluirCostosImportacion = 127,
  GenerarRecepcion = 124,
  AgregarEquipos = 125,
  GenerarMovimiento = 132,
  GenerarEncomienda = 134,
  DevolverSeriado = 129,
  FacturacionManual = 130,
  Facturar = 136,
  Finalizar = 128,
  ver_evidencias = 133,
  accionDevolverAFInanzas = 126,
  ActualizarEstado = 140,
  ActualizarNDV = 141,
  ReservarEquipos = 142,
  GestionarDespacho = 143,
}

export type AccionesUsuario = {
  clienteId?: number;
  perfilId?: number;
  moduloCodigo?: number;
  moduloNombre?: string;
  accionCodigo?: number;
  nombreAccion?: string;
  subAcciones?: SubAccion;
};

export type SubAccion = {
  CodigoAccionPadre: number;
  nombreAccionPadre: string;
  CodigoSubAccion?: number;
  NombreSubAccion?: string;
};

export type PermisoAccion = {
  accionCodigo: number;
  visible?: boolean;
  moduloCodigo?: number;
};

// Revisar codigo BD Accion
export const codigoAccionesMenuItem = {
  accionExportar: 6,
  accionEditar: 3,
  accionVerDetalle: 4,
  accionCodigoEliminar: 5,
  accionDesbloquear: 13,
  accionAceptar: 14,
  accionDejarDeRecibir: 15,
  accionRechazar: 16,
  accionDejarDeCompartir: 17,
  accionAsociarGps: 34,
  accionCancelar: 48,
  accionDescargar: 72,
  accionCambiarPassword: 88,
  accionEnviarComando: 95,
  accionAnular: 94,
  accionEliminarApn: 96,
  accionEditarApn: 97,
  accionEliminarStock: 98,
  accionEditarStock: 99,
  accionEliminarApnCrear: 100,
  accionEditarApnCrear: 101,
  accionEliminarStockCrear: 102,
  accionEditarStockCrear: 103,
  accionEliminarPlanCrear: 104,
  accionEditarPlanCrear: 105,
  accionExportaraCRM: 106,
  accionVerHistorico: 112,
  accionSolicitarAutorizacion: 110,
  accionVerAutorizacion: 111,
  accionTraza: 114,
  accionInformarRecepcion: 118,
  accionEditarAutorizadores: 116,
  accionImportar: 108,
  accionRevertirEjecucion: 109,
  accionGenerarAtencion: 121,
  accionVerEstadoSeries: 120,
  accionIncluirCostosImportacion: 127,
  accionGenerarMovimiento: 132,
  GenerarEncomienda: 134,
  DevolverSeriado: 129,
  accionFacturacionManual: 130,
  Finalizar: 128,
  accion_ver_evidencias: 133,
  accionDevolverAFInanzas: 126,
  Facturar: 136,
  ActualizarEstado: 140,
  accionGestionarDespacho: 143,
};
